module.exports = __webpack_public_path__ + "static/media/tablet-android.ac80fd75.svg";